module.exports = __webpack_public_path__ + "static/about-2-sm-bb6ca9cbf67158494879320868add869.jpg";